// extracted by mini-css-extract-plugin
export default {"reset":"OnClickLink_reset__yVGpC","noHoverStyle":"OnClickLink_noHoverStyle__glZ7+"};